export default class A11y {
  constructor() {
    this.init();
  }

  init() {
    window.addEventListener('load', () => {
      const youtubeIframes = document.querySelectorAll('iframe[src*="www.youtube.com/embed/"]');

      youtubeIframes.forEach(video => {
        if (!video.getAttribute('title')) {
          const videoSrc = video.src;

          fetch(`https://noembed.com/embed?dataType=json&url=${videoSrc}`)
            .then(res => res.json())
            .then(data => {
              const title = data.title;
              video.setAttribute('title', `YouTube video : ${title}`);
            });
        }
      });
    });
  }
}
